export default __webpack_public_path__ + "static/media/question.e4486da4.svg";